module.exports = __webpack_public_path__ + "static/media/building3.da97ecee.svg";